<div cdkTrapFocus aria-live="assertive">
  <div class="modal-header">
    <h3 class="modal-title" id="modal-header" i18n="@@modalRailTicketTypes">Ticket Types</h3>
    <button
      type="button"
      class="close"
      id="close_ticket_types"
      aria-label="Ticket Types Close"
      ngbAutoFocus
      (click)="activeModal.dismiss()"
    >
      <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
    </button>
  </div>
  <div class="modal-body ticket_list">
    @for (ticket of tickets; track ticket; let i = $index) {
      <div class="ticket_item">
        <section class="container" (mouseleave)="tt.close()">
          <mat-radio-group [(ngModel)]="selectedTicket">
            <mat-radio-button
              [attr.aria-label]="
                'Select ' + (ticket.price | currency: ticket.currency) + ' ' + ticket.type
              "
              [value]="ticket"
              id="select_ticket_{{ i }}"
              [disabled]="!ticket.selectable || ticket.unavailable"
              [ngbTooltip]="
                ticket.unavailable ? 'Fare is unavailable due to being out of policy' : null
              "
              i18n-ngbTooltip
              (focus)="tt.open()"
              (blur)="tt.close()"
              (mouseenter)="tt.open()"
              #tt="ngbTooltip"
              triggers="manual"
            >
            </mat-radio-button>
          </mat-radio-group>
        </section>
        <div class="ticket_item_details_container flex-row-container--between; let j =index">
          <div class="flex-row-container flex-row-container--between">
            <span class="ticket_type">{{ ticket.type?.replace(',', ', ') }}</span>
            <button
              (click)="openRailTicketDetailsDialog(ticket)"
              i18n="@@modalRailViewConditions"
              class="conditions"
              id="select_conditions_{{ j }}"
              [attr.aria-label]="
                'View Conditions for ' +
                (ticket.price | currency: ticket.currency) +
                ' ' +
                ticket.type
              "
            >
              View Conditions
            </button>
          </div>
          <div class="flex-row-container flex-row-container--between price-row">
            <div class="price-and-warning">
              <span class="ticket_price">{{ ticket.price | currency: ticket.currency }}</span>
              <app-warning-tags [iconId]="ticket.fareHash" [ticket]="ticket"></app-warning-tags>
            </div>
            @if (ticket.identifiers?.isSplit) {
              <section class="container">
                <span>
                  <app-split-ticket-icon
                    [savings]="calculateSplitSavings(ticket).toString()"
                    [currency]="ticket.currency"
                    [ngbTooltip]="
                      'Split Ticket – This ticket will purchase multiple tickets to cover your journey' +
                      (calculateSplitSavings(ticket).toString() &&
                      +calculateSplitSavings(ticket).toString() > 0
                        ? ', saving ' +
                          (calculateSplitSavings(ticket)
                            | currency: ticket.currency : 'symbol' : '1.2-2') +
                          ' against the next available fare of the same ticket type.'
                        : '')
                    "
                    placement="top"
                    container="body"
                  >
                  </app-split-ticket-icon>
                </span>
              </section>
            }
            @if (!!ticket.eTicketAvailable) {
              <section (mouseleave)="ttet.close()" class="container">
                <img
                  i18n-ngbTooltip
                  ngbTooltip="This is an eTicket that may be SelfPrinted."
                  alt="This is an eTicket that may be SelfPrinted."
                  [src]="eTicketIcon"
                  class="ico-float-left"
                  tabindex="0"
                  triggers="manual"
                  #ttet="ngbTooltip"
                  (mouseenter)="ttet.open()"
                  (focus)="ttet.open()"
                  (blur)="ttet.close()"
                />
              </section>
            }
            @if (isGroupFare(ticket)) {
              <section class="container">
                @switch (sourceName) {
                  @case (ServiceProvider.Evolvi) {
                    <div (mouseleave)="tt10.close()">
                      <img
                        src="https://images.sabscorp.com/images/GroupDiscount.gif"
                        ngbTooltip="Group ticket - to qualify for this fare all travellers must travel together on the same ticket"
                        alt="Group ticket"
                        class="ico-float-left"
                        tabindex="0"
                        triggers="manual"
                        #tt10="ngbTooltip"
                        (mouseenter)="tt10.open()"
                        (focus)="tt10.open()"
                        (blur)="tt10.close()"
                      />
                    </div>
                  }
                  @case (ServiceProvider.Trainline) {
                    <div (mouseleave)="tt10.close()">
                      <span
                        ngbTooltip="GroupSave discount applied. All passengers must travel together"
                        class="ico-tl-group-save"
                        triggers="manual"
                        #tt10="ngbTooltip"
                        tabindex="0"
                        (mouseenter)="tt10.open()"
                        (focus)="tt10.open()"
                        (blur)="tt10.close()"
                        >GroupSave</span
                      >
                    </div>
                  }
                }
              </section>
            }
          </div>
        </div>
      </div>
    }
  </div>
  <div class="modal-footer">
    <button
      type="button"
      id="button_ok"
      i18n="@@modalRailOk"
      appButton="small"
      (click)="activeModal.close(selectedTicket)"
    >
      Ok
    </button>
  </div>
</div>
